import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TData } from 'entries/common/widgets/context';
import { TComplimentaryProductsState } from 'pages/calculation/types/complimentary-products-state.type';
import { TCalculateData } from 'pages/dimensions/store/dimensions';
import { TEditConfigurationGeneralItem } from 'pages/common/types';

export const configurateGeneralItems = ({
  dimensions,
  data,
  count,
  complimentaryProducts,
}: {
  dimensions: TCalculateData;
  data: TData | null;
  count: number;
  complimentaryProducts: TComplimentaryProductsState;
}) => {
  const mainProducts = dimensions.items.map((item, idx) => ({
    itemId: String(idx + 1),
    code: item.productId,
    type: 'PRODUCT',
    name: data?.displayedName,
    quantity: count,
    price: data?.mainPrice,
    complementary: false,
  }));

  const resultArr: TEditConfigurationGeneralItem[] = [...mainProducts];

  Object.values(complimentaryProducts).forEach(item => {
    const isCheckedProduct = getIsCheckedProducts({
      checkedProducts: dimensions.checkedProducts,
      productId: item.productId,
    });

    if (isCheckedProduct) {
      resultArr.push({
        itemId: String(resultArr.length + 1),
        code: item.productId,
        type: 'PRODUCT',
        name: item.displayedName.value?.[0],
        quantity: item.total.requiredQuantity,
        price: item.salesPriceValueInConsumerUnitValue ?? 0,
        complementary: true,
      });
    }
  });

  return resultArr;
};
